import { useMemo } from 'react';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';

export default function useAudienceOptions(audiences) {
  return useMemo(() => {
    const audienceOptions = sortBy(
      map(audiences, audience => ({
        value: audience.id,
        label: audience.name,
      })),
      v => v.label.toLowerCase()
    );
    audienceOptions.unshift({ value: '', label: 'None' });
    return audienceOptions;
  }, [audiences]);
}
